import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
} from "@angular/core";
import { PLAuctionEntry } from "src/app/Shared/Model/pl-auction-entry";
import { FormGroup, FormBuilder, FormArray, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { Router } from "@angular/router";
import { MatSort } from "@angular/material/sort";
import { AuctionEntryServiceService } from "src/app/Shared/Services/auction-entry-service.service";
import { ToastrService } from "ngx-toastr";
import { DateCompareService } from "src/app/Shared/Services/date-compare.service";
import { TranslationService } from "src/app/Shared/Model/TranslationService";
import { Observable } from 'rxjs';            // Import Observable
import { map } from 'rxjs/operators';
declare var $: any;
@Component({
  selector: "app-auction-entry",
  templateUrl: "./auction-entry.component.html",
  styleUrls: ["./auction-entry.component.css"],
})
export class AuctionEntryComponent implements OnInit { 
  FrmAuctionEntry: FormGroup;
  loginlist: any = [];
  e = [];
  Documents: FormArray;
  DocumentsAuctionList: any = [];
  DocumentsAuctionListGrid: any = [];

  displayedColumnsDocuments: string[] = [
    "SrNo",
    "DocumentName",
    "Description",
    "FileName",
    "Action",
  ]; ////'Type',
  dataSourceDocuments = new MatTableDataSource(this.DocumentsAuctionList);

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  model: PLAuctionEntry;
  uploadfilename: string = "";
  
  AutoIdImage: string;
  RegistrationDateinvalidMsg: string;
  dateValidationMsg: string;
  ddlDepartmentList: any[];
  ddlAuthorityList: any[];
  ddlAuctionTypeList: any[];
  ddlBiddingTypeList: any[];
  ddlOfficerList: any[];
  ddlZoneList: any[];
  ListDA: any[];
  ListRO: any[];
  ListDC: any[];
  pdfSrc: any;
  title = "Check";
  fileData: File = null;
  formData: string = null;
  filename: string = null;
  base64url: any;
  minDate: Date;
  maxDate: Date;
  pnlDocsHideShow: boolean = false;

  checkAppDate: boolean = false;
  checkAppDateReverse: boolean = false;
  ParticipationDocsList: any = [];
  translatedText: string = '';
  location: string = '';

  constructor(
    private fb: FormBuilder,
    private MsgService: ToastrService,
    private router: Router,
    private AuctionEntryService: AuctionEntryServiceService,
    private CompareSrvc: DateCompareService
    ,private translationService: TranslationService
  ) {  }

  ngOnInit() {
    //this.FrmAuctionEntry.controls['Verification'];
    this.minDate = new Date(2020, 0, 1);
    this.maxDate = new Date();
    this.FillAllDDL();
    this.CreateAuctionEntry();

    this.FrmAuctionEntry.controls["txtAllext1"].disable();
    this.FrmAuctionEntry.controls["txtAllext2"].disable();
    this.FrmAuctionEntry.controls["txtAllext3"].disable();
    this.FrmAuctionEntry.controls["txtAllext4"].disable();

    this.FrmAuctionEntry.controls["txtAllext1"].setValue("");
    this.FrmAuctionEntry.controls["txtAllext2"].setValue("");
    this.FrmAuctionEntry.controls["txtAllext3"].setValue("");
    this.FrmAuctionEntry.controls["txtAllext4"].setValue("");
    // this.FrmAuctionEntry.controls['ddlVerifyDA'].disable();
    // this.FrmAuctionEntry.controls['ddlVerifyRO'].disable();
    // this.FrmAuctionEntry.controls['ddlVerifyDC'].disable();

    //this.FrmAuctionEntry.get('Verification').reset(1);
  }
  // add By Mayank 07/02/2025 start
  TranslationAPI(translateValue: any): Observable<string> {        
    const txtBox = translateValue;  // Get the text to translate
    return this.translationService.translateText(txtBox).pipe(
      map(response => response[0].translations[0].text)  // Extract the translated text
    );
  }

  OnLanguageType_SelectIndexChange(){
    this.FrmAuctionEntry.controls['txtAuctionTitle'].setValue('');
    this.FrmAuctionEntry.controls['txtLocation'].setValue('');
    this.FrmAuctionEntry.controls['txtDetails'].setValue('');    
  }
  
  OnTranslationService(event: any, TxtID: string): void {   
    if( this.FrmAuctionEntry.controls["ddlLanguage"].value == 1)
  {
    this.TranslationAPI(event.target.value).subscribe(
      (translatedText) => {              
          this.FrmAuctionEntry.controls[TxtID].setValue(translatedText);        
        console.log('Translated Text:', translatedText);
      },
      (error) => {
        console.error('Error translating text:', error);
      }
    );
  }
 }
// End
  CreateAuctionEntry() {
    this.FrmAuctionEntry = this.fb.group({
      ddlDepartment: ["", Validators.required],
      txtAuctionNo: ["", [Validators.required, Validators.maxLength(20)]],
      txtAuctionPublishDate: [
        "",
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(10),
        ],
      ],
      txtAuctionTitle: ["", [Validators.required, Validators.maxLength(100)]],
      txtLocation: ["", [Validators.required, Validators.maxLength(150)]],
      txtDetails: ["", [Validators.required, Validators.maxLength(200)]],
      ////txtDescription: ['', [Validators.required, Validators.maxLength(300)]],
      ddlAuthority: ["", Validators.required],
      ddlAuctionType: ["", Validators.required],
      ddlBiddingType: ["", Validators.required],
      txtIncreaseDecreaseAmt: [
        "",
        [Validators.required, Validators.maxLength(15)],
      ],
      txtEstimatedAuctionAmt: [""], //[Validators.required, Validators.maxLength(15)]
      txtAuctionFees: ["", [Validators.required, Validators.maxLength(15)]],
      txtRegistrationDateFrom: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtRegistrationDateTo: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtStartingPrice: ["", [Validators.required, Validators.maxLength(15)]],
      txtEMDSubmissionAmt: [
        "",
        [Validators.required, Validators.maxLength(15)],
      ],
      txtEMDSumissionDateFrom: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtEMDSubmissionStartTime: ["", Validators.required],
      txtEMDSubmissionEndTime: ["", Validators.required],
      txtEMDSubmissionDateTo: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtAuctionStartDate: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtAuctionStartTime: ["", Validators.required],
      txtAuctionEndDate: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtAuctionEndTime: ["", Validators.required],
      file: [""],
      ddlZone: ["", Validators.required],
      ddlOfficer: ["", Validators.required],
      txtFinalAuctionEndTime: ["", Validators.required],
      txtDocumentName: [""],
      //// txtDocumentType: [''],
      txtDocumentDescription: [""],
      ChkParticipationDocs: ["", Validators.required],
      Verification: ["1", Validators.required],
      ShowWinner: ["0", Validators.required],
      AllowedExemption: ["0", Validators.required],
      ddlVerifyDA: ["", Validators.required],
      ddlVerifyRO: ["", Validators.required],
      ddlVerifyDC: ["", Validators.required],
      txtLatitude: ["", Validators.required],
      txtLongitude: [
        "",
        Validators.required,
        ,
        Validators.pattern("^(0|[1-9][0-9]*)$"),
      ],
      ddlLanguage: ["", Validators.required],
      txtAllext1: ["", Validators.required],
      txtAllext2: ["", Validators.required],
      txtAllext3: ["", Validators.required],
      txtAllext4: ["", Validators.required],
      chkLatLong: ["", Validators.required],
      chkAllowExnt: ["", Validators.required],
      txtRegistrationTimeFrom: ['', Validators.required],
      txtRegistrationTimeTo: ['', Validators.required],
      // chkEndDate: ["", Validators.required],
      // Documents: this.fb.array([this.createItem()])
      //(change) = "RadioChange($event)"
    });
  }
  /**
   *
   * ******************************* Start Date Compare Validation *******************/
  isNumberKey(event) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      if (charCode != 45) return false;
    }
    return true;
  }
  OnRegistrationDateFrom() {
    var AuctionPublishedDate = $("#txtAuctionPublishDate1").val();
    let RegDateFrom = $("#txtRegistrationDateFrom1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(
      AuctionPublishedDate,
      RegDateFrom
    );
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionEntry.get("txtRegistrationDateFrom").reset("");
      this.MsgService.warning(
        "Participation Start Date Can Not Be Less then Auction Published Date..!!"
      );
      return;
    }
    this.checkAppDateReverse = this.CompareSrvc.DateCompareReverse(
      RegDateFrom,
      AuctionPublishedDate
    );
    if (this.checkAppDateReverse === true) {
      this.FrmAuctionEntry.get("txtRegistrationDateFrom").reset("");
      this.MsgService.warning(
        "Participation Start Date Can Not Be Less then Auction Published Date..!!"
      );
      return;
    }
  }
  OnRegistrationDateTo() {
    let RegDateFrom = $("#txtRegistrationDateFrom1").val();
    let RegDateTo = $("#txtRegistrationDateTo1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(RegDateFrom, RegDateTo);
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionEntry.get("txtRegistrationDateTo").reset("");
      this.MsgService.warning(
        "Participation End Date Can Not Be Less then Participation Start Date..!!"
      );
      return;
    }
  }
  OnEMDDateFrom() {
    let RegDateFrom = $("#txtRegistrationDateFrom1").val();

    let EMDDateFrom = $("#txtEMDSumissionDateFrom1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(RegDateFrom, EMDDateFrom);
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionEntry.get("txtEMDSumissionDateFrom").reset("");
      this.MsgService.warning(
        "EMD Submission Start Date Can Not Be Less then Participation Start Date..!!"
      );
      return;
    }
  }
  OnEMDDateTo() {
    let EMDDateFrom = $("#txtEMDSumissionDateFrom1").val();
    let EMDDateTo = $("#txtEMDSubmissionDateTo1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(EMDDateFrom, EMDDateTo);
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionEntry.get("txtEMDSubmissionDateTo").reset("");
      this.MsgService.warning(
        "EMD Submission End Date Can Not Be Less then EMD Submission Start Date..!!"
      );
      return;
    }
  }
  OnAuctionStartDate() {
    let EMDDateTo = $("#txtEMDSubmissionDateTo1").val();
    let AuctionStartDate = $("#txtAuctionStartDate1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(
      EMDDateTo,
      AuctionStartDate
    );
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionEntry.get("txtAuctionStartDate").reset("");
      this.MsgService.warning(
        "Auction Start Date Can Not Be Less then EMD Submission End Date..!!"
      );
      return;
    }
  }
  OnAuctionEndDate() {
    let AuctionStartDate = $("#txtAuctionStartDate1").val();
    let AuctionEndDate = $("#txtAuctionEndDate1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(
      AuctionStartDate,
      AuctionEndDate
    );
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionEntry.get("txtAuctionEndDate").reset("");
      this.MsgService.warning(
        "Auction End Date Can Not Be Less then Auction Start Date..!!"
      );
      return;
    }
  }
  /*************************************** END Date Compare Validation *****************************************/
  OnAdd() {
    this.DocumentsAuctionList = [];
    this.DocumentsAuctionList = [
      {
        DocumentName: this.FrmAuctionEntry.controls["txtDocumentName"].value,
        DocumentType: "", //// this.FrmAuctionEntry.controls['txtDocumentType'].value,
        Description:
          this.FrmAuctionEntry.controls["txtDocumentDescription"].value,
        FileName: this.uploadfilename,
        File: this.base64url.split(",")[1],
      },
    ];

    this.DocumentsAuctionList.forEach((i: any) => {
      this.DocumentsAuctionListGrid.push(i);
    });
    this.dataSourceDocuments = new MatTableDataSource<any>(
      this.DocumentsAuctionListGrid
    );
    this.dataSourceDocuments.paginator = this.paginator.toArray[0];
    this.dataSourceDocuments.sort = this.sort.toArray[0];
    this.uploadfilename = "";
    this.FrmAuctionEntry.controls["txtDocumentName"].setValue("");
    //// this.FrmAuctionEntry.controls['txtDocumentType'].setValue('');
    this.FrmAuctionEntry.controls["txtDocumentDescription"].setValue("");
    this.FrmAuctionEntry.controls["file"].setValue("");
  }
  OnRemove(DocumentName: string, Description: string, FileName: string) {
    this.DocumentsAuctionListGrid = this.DocumentsAuctionListGrid.filter(
      (a) =>
        a.DocumentName != DocumentName &&
        a.Description != Description &&
        a.FileName != FileName
    );
    this.dataSourceDocuments = null;
    this.dataSourceDocuments = new MatTableDataSource<any>(
      this.DocumentsAuctionListGrid
    );
    this.dataSourceDocuments.paginator = this.paginator.toArray[0];
    this.dataSourceDocuments.sort = this.sort.toArray[0];
  }
  Clear() {
    this.FrmAuctionEntry.reset("");
    this.uploadfilename = "";
    this.dataSourceDocuments = null;
    this.DocumentsAuctionListGrid = [];
    this.ChkParticipationDocsLst = [];
    this.ParticipationDocsList = [];
    this.pnlDocsHideShow = false;

    this.FrmAuctionEntry.controls["Verification"].setValue("1");
    this.FrmAuctionEntry.controls["ShowWinner"].setValue("0");
    this.FrmAuctionEntry.controls["AllowedExemption"].setValue("0");
  }
  RadioChange(evt) {
    var target = evt.target.value;
    if (target == 1) {
      this.FrmAuctionEntry.controls["ddlVerifyDA"].enable();
      this.FrmAuctionEntry.controls["ddlVerifyRO"].enable();
      this.FrmAuctionEntry.controls["ddlVerifyDC"].enable();
    } else {
      this.FrmAuctionEntry.controls["ddlVerifyDA"].disable();
      this.FrmAuctionEntry.controls["ddlVerifyRO"].disable();
      this.FrmAuctionEntry.controls["ddlVerifyDC"].disable();
    }
  }

  chkAllowExtension(evt) {
    if (evt.checked == true) {
      this.FrmAuctionEntry.controls["txtAllext1"].enable();
      this.FrmAuctionEntry.controls["txtAllext2"].enable();
      this.FrmAuctionEntry.controls["txtAllext3"].enable();
      this.FrmAuctionEntry.controls["txtAllext4"].enable();
    } else {
      this.FrmAuctionEntry.controls["txtAllext1"].disable();
      this.FrmAuctionEntry.controls["txtAllext2"].disable();
      this.FrmAuctionEntry.controls["txtAllext3"].disable();
      this.FrmAuctionEntry.controls["txtAllext4"].disable();

      this.FrmAuctionEntry.controls["txtAllext1"].setValue("");
      this.FrmAuctionEntry.controls["txtAllext2"].setValue("");
      this.FrmAuctionEntry.controls["txtAllext3"].setValue("");
      this.FrmAuctionEntry.controls["txtAllext4"].setValue("");
    }
  }
  ChkLatitudeLogitudeEvent(evt) {
    if (evt.checked == true) {
      this.FrmAuctionEntry.controls["txtLatitude"].enable();
      this.FrmAuctionEntry.controls["txtLongitude"].enable();
    } else {
      this.FrmAuctionEntry.controls["txtLatitude"].disable();
      this.FrmAuctionEntry.controls["txtLongitude"].disable();

      this.FrmAuctionEntry.controls["txtLatitude"].setValue("");
      this.FrmAuctionEntry.controls["txtLongitude"].setValue("");
    }
  }
  OnAuctionEntry() {
    try {
      let a = this.FrmAuctionEntry.get("Verification").value;
      if (a != 1 && a != 2) {
        this.MsgService.error("Please Select Participation verification...!!");
        return;
      }
      if (a == 2) {
        this.ChkParticipationDocsLst = [];
        this.ChkParticipationDocsLst.push({ DocId: null, DocName: null });
      } else {
        if (this.ChkParticipationDocsLst.length == 0) {
          this.MsgService.error(
            "Please Check Atleast 1 Participation Docs Type...!!"
          );
          return;
        }
      }
      if (this.FrmAuctionEntry.controls['txtRegistrationTimeFrom'].value == '' || this.FrmAuctionEntry.controls['txtRegistrationTimeFrom'].value == null|| this.FrmAuctionEntry.controls['txtRegistrationTimeFrom'].value == '00:00:00') {
        this.MsgService.warning("Please Entry Correct Registration Time From...!!");
        return;
      }
      if (this.FrmAuctionEntry.controls['txtRegistrationTimeTo'].value == '' || this.FrmAuctionEntry.controls['txtRegistrationTimeTo'].value == null|| this.FrmAuctionEntry.controls['txtRegistrationTimeTo'].value == '00:00:00') {
        this.MsgService.warning("Please Entry Correct Registration Time To...!!");
        return;
      }
      // this.FrmAuctionEntry.controls['file']
      this.model = new PLAuctionEntry();
      this.model.Ind = 1;
      this.model.ParticipationVerificationInd = a;
      if (a == 1) {
        this.model.DAUserId =
          this.FrmAuctionEntry.controls["ddlVerifyDA"].value;
        this.model.ROUserId =
          this.FrmAuctionEntry.controls["ddlVerifyRO"].value;
        this.model.DCUserId =
          this.FrmAuctionEntry.controls["ddlVerifyDC"].value;
      } else {
        this.model.DAUserId = 0;
        this.model.ROUserId = 0;
        this.model.DCUserId = 0;
      }
      // *************************************change 16012020 *****************************
      let ResponseDecrpt = sessionStorage.getItem("loginSession");
      this.loginlist = JSON.parse(window.atob(ResponseDecrpt));
      this.model.OrgCode = this.loginlist[0]["OrgCode"];
      this.model.CityCode = this.loginlist[0]["CityCode"];
      this.model.UserId = this.loginlist[0]["UserId"];
      // ****************end*************************************************

      this.model.DeptCode =
        this.FrmAuctionEntry.controls["ddlDepartment"].value;
      this.model.ZoneCode = this.FrmAuctionEntry.controls["ddlZone"].value;
      this.model.OfficerCode =
        this.FrmAuctionEntry.controls["ddlOfficer"].value;
      this.model.AuctionNo =
        this.FrmAuctionEntry.controls["txtAuctionNo"].value;
      // this.model.AuctionPublishDate = this.FrmAuctionEntry.controls['txtAuctionPublishDate'].value;
      this.model.AuctionPublishDate = $("#txtAuctionPublishDate1").val();

      this.model.AuctionAuthorityCd =
        this.FrmAuctionEntry.controls["ddlAuthority"].value;
      this.model.AuctionTypeCd =
        this.FrmAuctionEntry.controls["ddlAuctionType"].value;
      this.model.AuctionSubTypeCd = 0;
      this.model.AuctionTitle =
        this.FrmAuctionEntry.controls["txtAuctionTitle"].value;
      this.model.AuctionLocation =
        this.FrmAuctionEntry.controls["txtLocation"].value;
      this.model.AuctionDetail =
        this.FrmAuctionEntry.controls["txtDetails"].value;
      this.model.Description = ""; /////this.FrmAuctionEntry.controls['txtDescription'].value;
      this.model.AuctionAmt =
        this.FrmAuctionEntry.controls["txtEstimatedAuctionAmt"].value == ""
          ? null
          : this.FrmAuctionEntry.controls["txtEstimatedAuctionAmt"].value;
      this.model.StartingPrice =
        this.FrmAuctionEntry.controls["txtStartingPrice"].value;
      this.model.AuctionFee =
        this.FrmAuctionEntry.controls["txtAuctionFees"].value;
      //  this.model.ContactPersonName = this.FrmAuctionEntry.controls['ddlAssetsCode'].value;
      //this.model.ContactMobileNo = this.FrmAuctionEntry.controls['ddlAssetsCode'].value;

      // this.model.RegistrationDateFrom = this.FrmAuctionEntry.controls['txtRegistrationDateFrom'].value;
      // this.model.RegistrationDateTo = this.FrmAuctionEntry.controls['txtRegistrationDateTo'].value;
      this.model.RegistrationDateFrom = $("#txtRegistrationDateFrom1").val();

      this.model.RegistrationDateTo = $("#txtRegistrationDateTo1").val();
      this.model.RegistrationStarttime = this.FrmAuctionEntry.controls['txtRegistrationTimeFrom'].value;
      this.model.RegistrationEndtime = this.FrmAuctionEntry.controls['txtRegistrationTimeTo'].value;
    

      // if (this.model.RegistrationDateFrom > this.model.RegistrationDateTo) {
      //   this.MsgService.error("Registration From Date cannot more then Registration To Date");
      //   return false;
      // }
      this.model.EMDAmt =
        this.FrmAuctionEntry.controls["txtEMDSubmissionAmt"].value;

      this.model.EMDSubimissionStartDate = $("#txtEMDSumissionDateFrom1").val();

      this.model.EMDSubimissionStarttime =
        this.FrmAuctionEntry.controls["txtEMDSubmissionStartTime"].value;
      this.model.EMDSubimissionEndDate = $("#txtEMDSubmissionDateTo1").val();

      // if (this.model.EMDSubimissionStartDate > this.model.EMDSubimissionEndDate) {
      //   this.MsgService.error("EMD Subimission Start Date cannot more then EMD Subimission end Date ");
      //   return false;
      // }
      this.model.EMDSubimissionEndtime =
        this.FrmAuctionEntry.controls["txtEMDSubmissionEndTime"].value;
      this.model.AuctionStartDate = $("#txtAuctionStartDate1").val();

      // if (this.model.AuctionStartDate < this.model.RegistrationDateTo) {
      //   this.MsgService.error("Auction Start Date can not be less then Registration Date To");
      //   return false;
      // }
      if (this.DocumentsAuctionListGrid == null) {
        this.MsgService.error("Please Upload atleast 1 PDF ");
        return false;
      }
      this.model.AuctionStartTime =
        this.FrmAuctionEntry.controls["txtAuctionStartTime"].value;
      this.model.AuctionEndDate = $("#txtAuctionEndDate1").val();

      this.model.AuctionEndTime =
        this.FrmAuctionEntry.controls["txtAuctionEndTime"].value;
      this.model.AuctionPeriod = 0;
      this.model.FinalAuctionEndTime =
        this.FrmAuctionEntry.controls["txtFinalAuctionEndTime"].value;
      this.model.IncrementalAmt =
        this.FrmAuctionEntry.controls["txtIncreaseDecreaseAmt"].value;
      this.model.BiddingTypeId =
        this.FrmAuctionEntry.controls["ddlBiddingType"].value;
      this.model.DocumentList = this.DocumentsAuctionListGrid;

      //Change 09022021
      this.model.WinnerShowInd = this.FrmAuctionEntry.get("ShowWinner").value;
      this.model.AllowedExemptionInd =
        this.FrmAuctionEntry.get("AllowedExemption").value;

      // Change 04-07-2020
      this.model.ParticipationDocsList = this.ChkParticipationDocsLst;
      if (this.FrmAuctionEntry.get("chkLatLong").value == true) {
        this.model.LatLongInd = 1;
        this.model.Latitude = this.FrmAuctionEntry.get("txtLatitude").value;
        this.model.Longitude = this.FrmAuctionEntry.get("txtLongitude").value;
      } else {
        this.model.LatLongInd = 0;

        this.model.Latitude = "0";
        this.model.Longitude = "0";
      }
      if (this.FrmAuctionEntry.get("chkAllowExnt").value == true) {
        this.model.AllowExtInd = 1;
        this.model.Allowautoextension =
          this.FrmAuctionEntry.get("txtAllext1").value;
        this.model.checkforextension =
          this.FrmAuctionEntry.get("txtAllext2").value;
        this.model.AutoExtensionTime =
          this.FrmAuctionEntry.get("txtAllext3").value;
        this.model.AutoExtensionlimit =
          this.FrmAuctionEntry.get("txtAllext4").value;
      } else {
        this.model.AllowExtInd = 0;
        this.model.Allowautoextension = "0";
        this.model.checkforextension = "0";
        this.model.AutoExtensionTime = "0";
        this.model.AutoExtensionlimit = "0";
      }

      // if (this.FrmAuctionEntry.get("chkEndDate").value == true) {
      //   this.model.EndDateInd = 1;
      // } else {
      //   this.model.EndDateInd = 0;}

      this.AuctionEntryService.SaveAuctionEntry(this.model).subscribe(
        (respdata) => {
          this.AutoIdImage = "0";
          if (respdata != "" && respdata.SuccessCD == 1) {
            this.MsgService.success(respdata.Msg);
          }
          if (respdata != "" && respdata.SuccessCD == 2) {
            this.MsgService.warning("This Auction no. is Already Registered ");
          }
          if (respdata.RespData[0]["res"] == 0) {
            this.MsgService.warning(respdata.Msg);
          }
        }
      );
      this.Clear();
    } catch (err) {}
  }
  fileProgress1(event: any) {
    this.uploadfilename = "";
    let files = new FileReader();
    let file = event.target.files[0];
    var FileSize = file.size / 1024;
    let FileName = file.name;

    var mimeType = file.type;

    if (mimeType.match(/pdf\/*/) == null) {
      alert("Only Pdf are supported.");
      return;
    }
    if (FileName.match(/-\/*./) != null) {
      alert(
        "Please Rename the pdf name You Can't Use special Characters i.e. ($,-,@,.,*)"
      );
      return;
    }

    if (FileSize > 5000) {
      alert("Max file size allowed is 5 MB. Allowed file type Only pdf.");
      return;
    }

    this.uploadfilename = file.name;
    files.readAsDataURL(file);
    files.onload = () => {
      this.base64url = files.result;
    };
    event.target.value = "";

    // console.log(this.base64url);
  }
  fileProgress(event) {
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          // console.log(event.target.result);
          this.e.push(event.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }
  /***************Change 04-07-2020 **************/
  ChkParticipationDocsLst: any = [];
  OnChkParticipationDocs(event, DocLst) {
    if (event.source.checked) {
      this.ChkParticipationDocsLst.push({
        DocId: DocLst.DocId,
        DocName: DocLst.DocDesc,
      });
    } else {
      let removeIndex = this.ChkParticipationDocsLst.findIndex(
        (item) => item.DocId == DocLst.DocId
      );
      this.ChkParticipationDocsLst.splice(removeIndex, 1);
    }
  }

  FillAllDDL() {
    let ResponseDecrpt = sessionStorage.getItem("loginSession");
    this.loginlist = JSON.parse(window.atob(ResponseDecrpt));
    let OrgCode = this.loginlist[0]["OrgCode"];

    let UserLevelId = this.loginlist[0]["UserLevelId"];
    let ZoneCode = this.loginlist[0]["ZoneCode"];
    this.AuctionEntryService.GetAllDDL(OrgCode).subscribe((respdata) => {
      if (respdata != "" && respdata.SuccessCD == 1) {
        if (respdata.RespData.Table.length > 0) {
          // console.log(respdata)
          this.ddlDepartmentList = respdata.RespData.Table;
          this.ddlAuthorityList = respdata.RespData.Table1;
          this.ddlAuctionTypeList = respdata.RespData.Table2;
          this.ddlBiddingTypeList = respdata.RespData.Table3;

          if (UserLevelId == 6) {
            this.ddlZoneList = respdata.RespData.Table5;
            this.FrmAuctionEntry.controls["ddlZone"].disable();
            this.FrmAuctionEntry.controls["ddlZone"].setValue(ZoneCode);
          } else {
            this.ddlZoneList = respdata.RespData.Table5;
          }

          // this.ParticipationDocsList = respdata.RespData.Table6;

          //this.ddlOfficerList = respdata.RespData.Table4
        }
      } else {
        if (respdata != "" && respdata.SuccessCD == 0) {
          this.MsgService.warning(respdata.MsgDesc);
        } else {
          this.MsgService.error("Not Found");
        }
      }
    });
  }
  OnAuctionType_SelectIndexChange() {
    this.ParticipationDocsList = [];
    let ResponseDecrpt = sessionStorage.getItem("loginSession");
    this.loginlist = JSON.parse(window.atob(ResponseDecrpt));
    let OrgCode = this.loginlist[0]["OrgCode"];
    let CityCode = this.loginlist[0]["CityCode"];
    let Ind = 9;

    if (
      this.FrmAuctionEntry.controls["ddlAuctionType"].value != "0" &&
      this.FrmAuctionEntry.controls["ddlAuctionType"].value != null
    ) {
      let AuctionType = this.FrmAuctionEntry.controls["ddlAuctionType"].value;
      this.AuctionEntryService.GetDocumentListCategoryWise(
        Ind,
        AuctionType,
        OrgCode,
        CityCode
      ).subscribe((respdata) => {
        if (respdata != "" && respdata.SuccessCD == 1) {
          if (respdata.RespData.Table.length > 0) {
            this.ParticipationDocsList = respdata.RespData.Table;
            this.pnlDocsHideShow = true;
          }
        } else {
          if (respdata != "" && respdata.SuccessCD == 0) {
            this.MsgService.warning(respdata.MsgDesc);
          } else {
            this.MsgService.error("Not Found");
          }
        }
      });
    }
  }
  OnZone_SelectIndex() {
    this.ListDC = [];
    this.ListRO = [];
    this.ListDA = [];
    this.ddlOfficerList = [];
    if (this.FrmAuctionEntry.controls["ddlZone"].value != "0") {
      let Zonecd = this.FrmAuctionEntry.controls["ddlZone"].value;
      this.AuctionEntryService.GetFillOfficer(Zonecd).subscribe((respdata) => {
        if (respdata != "" && respdata.SuccessCD == 1) {
          if (respdata.RespData.Table.length > 0) {
            this.ddlOfficerList = respdata.RespData.Table;
            this.ListDA = respdata.RespData.Table1;
            this.ListRO = respdata.RespData.Table2;
            this.ListDC = respdata.RespData.Table3;
          }
        } else {
          if (respdata != "" && respdata.SuccessCD == 0) {
            this.MsgService.warning(respdata.MsgDesc);
          } else {
            this.MsgService.error("Not Found");
          }
        }
      });
    }
  }
  get AddDisable() {
    if (
      this.FrmAuctionEntry.controls["txtDocumentName"].value == "" ||
      this.FrmAuctionEntry.controls["txtDocumentName"].value == null
    ) {
      return true;
    }
    // // if (this.FrmAuctionEntry.controls['txtDocumentType'].value == '' || this.FrmAuctionEntry.controls['txtDocumentType'].value == null) {
    // //   return true;
    // // }
    if (
      this.FrmAuctionEntry.controls["txtDocumentDescription"].value == "" ||
      this.FrmAuctionEntry.controls["txtDocumentDescription"].value == null
    ) {
      return true;
    }
    if (this.uploadfilename == "" || this.uploadfilename == null) {
      return true;
    }
    return false;
  }
  get SubmitDisable() {
    if (this.FrmAuctionEntry.controls["txtAuctionNo"].invalid == true) {
      return true;
    }
    if (
      this.FrmAuctionEntry.controls["txtAuctionPublishDate"].invalid == true
    ) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["txtAuctionTitle"].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["txtLocation"].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["txtDetails"].invalid == true) {
      return true;
    }

    if (this.FrmAuctionEntry.controls['ddlLanguage'].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["ddlAuthority"].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["ddlAuctionType"].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["ddlBiddingType"].invalid == true) {
      return true;
    }
    if (
      this.FrmAuctionEntry.controls["txtIncreaseDecreaseAmt"].invalid == true
    ) {
      return true;
    }
    // if (this.FrmAuctionEntry.controls['txtEstimatedAuctionAmt'].invalid == true) {
    //   return true;
    // }
    if (this.FrmAuctionEntry.controls["txtAuctionFees"].invalid == true) {
      return true;
    }
    if (
      this.FrmAuctionEntry.controls["txtRegistrationDateFrom"].invalid == true
    ) {
      return true;
    }
    if (this.FrmAuctionEntry.controls['txtRegistrationTimeFrom'].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls['txtRegistrationTimeTo'].invalid == true) {
      return true;
    }
    if (
      this.FrmAuctionEntry.controls["txtRegistrationDateTo"].invalid == true
    ) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["txtStartingPrice"].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["txtEMDSubmissionAmt"].invalid == true) {
      return true;
    }
    if (
      this.FrmAuctionEntry.controls["txtEMDSumissionDateFrom"].invalid == true
    ) {
      return true;
    }
    if (
      this.FrmAuctionEntry.controls["txtEMDSubmissionStartTime"].invalid == true
    ) {
      return true;
    }
    if (
      this.FrmAuctionEntry.controls["txtEMDSubmissionEndTime"].invalid == true
    ) {
      return true;
    }
    if (
      this.FrmAuctionEntry.controls["txtEMDSubmissionDateTo"].invalid == true
    ) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["txtAuctionStartDate"].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["txtAuctionStartTime"].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["txtAuctionEndDate"].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["txtAuctionEndTime"].invalid == true) {
      return true;
    }
    if (
      this.FrmAuctionEntry.controls["txtFinalAuctionEndTime"].invalid == true
    ) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["ddlZone"].invalid == true) {
      return true;
    }
    if (this.FrmAuctionEntry.controls["ddlOfficer"].invalid == true) {
      return true;
    }
    if (
      this.DocumentsAuctionListGrid == null ||
      this.DocumentsAuctionListGrid == "" ||
      this.DocumentsAuctionListGrid == "undefined"
    ) {
      return true;
    }
    if (this.FrmAuctionEntry.get("Verification").value == 1) {
      if (this.FrmAuctionEntry.controls["ddlVerifyDA"].invalid == true) {
        return true;
      }
      if (this.FrmAuctionEntry.controls["ddlVerifyRO"].invalid == true) {
        return true;
      }
      if (this.FrmAuctionEntry.controls["ddlVerifyDC"].invalid == true) {
        return true;
      }
    }

    if (this.FrmAuctionEntry.get("chkLatLong").value == true) {
      if (this.FrmAuctionEntry.controls["txtLatitude"].invalid == true) {
        return true;
      }
      if (this.FrmAuctionEntry.controls["txtLongitude"].invalid == true) {
        return true;
      }
    }
    return false;
  }
}
